import { Resource as a, API as l } from "@coveo/platform-client";
const r = class r extends a {
  list(t, e) {
    return this.api.get(
      this.buildPath(`${r.baseUrl}/${t}/rules`, e)
    );
  }
  get(t, e) {
    return this.api.get(this.buildPath(`${r.baseUrl}/${t}/rules/${e}`));
  }
  delete(t, e) {
    return this.api.delete(this.buildPath(`${r.baseUrl}/${t}/rules/${e}`));
  }
  edit(t, e, i) {
    return this.api.put(`${r.baseUrl}/${t}/rules/${e}`, i);
  }
  create(t, e) {
    return this.api.post(`${r.baseUrl}/${t}/rules`, e);
  }
};
r.baseUrl = `/rest/organizations/${l.orgPlaceholder}/answer/v1/configs`;
let s = r;
export {
  s as AnswerRuleResource
};
//# sourceMappingURL=AnswerRuleResource.js.map
